import { effect, EffectRef, Injector } from '@angular/core';
import { icon } from '@fortawesome/fontawesome-svg-core';
import { faLocationPin } from '@fortawesome/pro-solid-svg-icons';
import { TranslocoService } from '@jsverse/transloco';
import { Map } from 'maplibre-gl';

import { AbstractMapControl } from '@connect-services/client/components/map/abstract-map-control';
import { PinService } from '@connect-services/client/services/pin.service';

export class PinControl extends AbstractMapControl {
    private readonly stateEffect: EffectRef;

    public constructor(
        map: Map,
        private readonly pinService: PinService,
        private readonly translocoService: TranslocoService,
        injector: Injector,
    ) {
        super();
        this.map = map;
        this.stateEffect = effect(() => this.refreshButton(this.pinService.canRead(), this.pinService.isActive()), {
            injector,
        });
    }

    public override onRemove(): void {
        this.stateEffect.destroy();
        super.onRemove();
    }

    protected initButton(): void {
        this.setupButton('pin-control', () => this.pinService.toggle(), ['pin-control']);
        this.refreshButton(this.pinService.canRead(), this.pinService.isActive());
    }

    private refreshButton(canRead: boolean, isActive: boolean): void {
        this.setButtonIcon(icon(faLocationPin).html[0]);
        this.setButtonState({
            isActive: isActive,
            isDisabled: !canRead,
        });
        this.button.disabled = !canRead;
        this.setButtonTitle(this.translocoService.translate(canRead ? 'pin.openPins' : 'insufficientPermissions'));
    }
}
